import { Component, input } from "@angular/core";
import { SizeProp } from "@fortawesome/angular-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-loading-icon",
  templateUrl: "./loading-icon.component.html",
  standalone: false,
})
export class LoadingIconComponent {
  size = input<SizeProp>("lg");
  faSpinner = faSpinner;
}
